"use client";

import Button, { type ButtonProps } from "@mui/material/Button";
import { Link } from "@/i18n/navigation";

/**
 * Locale-aware "Get started" button that navigates to the onboarding assistant.
 *
 * Wrapping `Button component={Link}` in a client component keeps the `Link`
 * binding on the client side, so this can be dropped into server components
 * (Hero, Header, Offerings) without passing a function prop across the
 * server/client boundary. `href` defaults to `/start`; pass it to carry a
 * package prefill (e.g. `/start?package=website`).
 */
export function StartCta({
  href = "/start",
  children,
  ...props
}: ButtonProps & { href?: string }) {
  return (
    <Button component={Link} href={href} {...props}>
      {children}
    </Button>
  );
}
